import { render } from "./FridgeReductionInfoPage.vue?vue&type=template&id=35071429&scoped=true&ts=true"
import script from "./FridgeReductionInfoPage.vue?vue&type=script&lang=ts"
export * from "./FridgeReductionInfoPage.vue?vue&type=script&lang=ts"

import "./FridgeReductionInfoPage.vue?vue&type=style&index=0&id=35071429&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35071429"]])

export default __exports__